export function getCurrentTime(): UnixTimeStamp {
  return Date.now();
}
